export default __webpack_public_path__ + "static/img-decasonic-4d18bf22d3217ce9e6e42e5b3d84550f.png";